/**
 * RulesContext.jsx
 *
 * Stellt das Rules-Objekt per React Context bereit.
 * fetchRules() wird einmalig beim Mount des Providers aufgerufen.
 * Bis die Antwort eintrifft ist der Wert rulesFallback (nie null).
 */

import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchRules } from '../services/rulesService';
import rulesFallback from '../constants/rulesFallback';

export const RulesContext = createContext(rulesFallback);

export function RulesProvider({ children }) {
  const [rules, setRules] = useState(rulesFallback);

  useEffect(() => {
    fetchRules().then((loadedRules) => {
      setRules(loadedRules);
    });
  }, []);

  return (
    <RulesContext.Provider value={rules}>
      {children}
    </RulesContext.Provider>
  );
}
